import { useState } from 'react';

export const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);

  const toggle = () => setState((prev) => !prev);
  const setToggleStatus = (value: boolean) => setState(Boolean(value));

  return [state, toggle, setToggleStatus] as const;
};
